// extracted by mini-css-extract-plugin
export default {"header":"Navbar_header__KoQXO","headerLogo":"Navbar_headerLogo__fEsMc","headerControls":"Navbar_headerControls__Es0Gu"};